export const getAssessment = courseHashedId => `/api/v1/member/assessments/${courseHashedId}`;
export const saveAnswer = assessmentHashedId => `/api/v1/member/assessments/${assessmentHashedId}/save`;
export const submit= assessmentHashedId => `/api/v1/member/assessments/${assessmentHashedId}/submit`;